import React from "react";
import { useTranslation } from "react-i18next";
import { SchoolDashboard } from "../../common/api";
import {
  formatIsoDateAsLocalTimezoneDate,
  formatIsoDateAsLocalTimezoneTime,
} from "./common";
import { MetricsCard, MetricsRow } from "./MetricsCard";
import { LessonExecutionStatusBadge } from "./LessonExecutionStatusBadge";
import {
  ActivityTable,
  CompletedFilter,
  SecondaryCell,
  SectionHeader,
  SectionTitle,
} from "./DashboardStyles";

export const SingleUserAnalyticsTab = ({
  dashboard,
  navigate,
}: {
  dashboard: SchoolDashboard & { is_at_single_user_level: true };
  navigate: (string) => void;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <MetricsRow>
        <MetricsCard
          label={t("dashboard_lessons_completed")}
          value={t("intcomma", {
            val: dashboard.lessons_completed_cnt,
          })}
        />
        <MetricsCard
          label={t("dashboard_hours_of_tutoring")}
          value={t("intcomma", {
            val: dashboard.time_spent_hours,
          })}
        />
      </MetricsRow>

      <SectionHeader className="mt-5">
        <SectionTitle>{t("dashboard_recent_activity")}</SectionTitle>
      </SectionHeader>
      <ActivityTable>
        <thead>
          <tr>
            <th scope="col">{t("dashboard_column_date")}</th>
            <th scope="col">{t("dashboard_column_time")}</th>
            <th scope="col">{t("dashboard_column_lesson_title")}</th>
            <th scope="col">{t("dashboard_time_spent_in_lesson")}</th>
            <th style={{ width: "1%" }} scope="col">
              {t("dashboard_column_completed")}{" "}
              <CompletedFilter
                showAll={dashboard.show_all_lesson_executions}
                toggleUrl={
                  dashboard.lesson_executions_filtered_the_other_way_url
                }
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {dashboard.lesson_executions.map((execution, index) => (
            <tr key={index}>
              <SecondaryCell>
                {formatIsoDateAsLocalTimezoneDate(execution.execution_date_iso)}
              </SecondaryCell>
              <SecondaryCell>
                {formatIsoDateAsLocalTimezoneTime(execution.execution_date_iso)}
              </SecondaryCell>
              <td>
                {execution.execution_url ? (
                  <a
                    href={execution.execution_url}
                    onClick={() => navigate(execution.execution_url)}
                  >
                    {execution.lesson_title}
                  </a>
                ) : (
                  execution.lesson_title
                )}
              </td>
              <SecondaryCell>{execution.execution_length}</SecondaryCell>
              <td>
                <LessonExecutionStatusBadge
                  isComplete={execution.is_complete}
                  isGood={execution.is_good}
                  isBad={execution.is_bad}
                  executionUrl={execution.execution_url}
                  onClick={(url) => navigate(url)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </ActivityTable>
    </>
  );
};
